import { render, staticRenderFns } from "./SegmentsEdit.vue?vue&type=template&id=562aadf2&"
import script from "./SegmentsEdit.vue?vue&type=script&lang=js&"
export * from "./SegmentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsEdit.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports